import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { useKeyboardInset } from "../hooks/useKeyboardInset";

type Props = {
  quote: string;
  onSubmit: (body: string) => void;
  onClose: () => void;
};

/**
 * Compose sheet stuck just above the soft keyboard
 * (Capacitor Keyboard height + visualViewport — not top-docked).
 */
export function AddCommentSheet({ quote, onSubmit, onClose }: Props) {
  const [body, setBody] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const keyboardInset = useKeyboardInset();

  useEffect(() => {
    const t = window.setTimeout(() => textareaRef.current?.focus(), 80);
    return () => window.clearTimeout(t);
  }, []);

  const submit = () => {
    const text = body.trim();
    if (!text) return;
    onSubmit(text);
  };

  const bottomPx = Math.max(0, keyboardInset);

  return (
    <div
      className="add-comment-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="add-comment-sheet"
        role="dialog"
        aria-label="افزودن کامنت"
        aria-modal="true"
        style={{
          bottom: bottomPx,
          top: "auto",
          paddingBottom:
            bottomPx > 0
              ? "0.75rem"
              : "calc(0.75rem + var(--safe-bottom))",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="add-comment-header">
          <span className="add-comment-title">افزودن کامنت</span>
          <button
            type="button"
            className="icon-btn"
            aria-label="بستن"
            onClick={onClose}
          >
            <X size={16} />
          </button>
        </div>
        {quote && (
          <div className="comment-quote add-comment-quote" title={quote}>
            {quote.length > 160 ? `${quote.slice(0, 160)}…` : quote}
          </div>
        )}
        <textarea
          ref={textareaRef}
          className="add-comment-input"
          dir="rtl"
          rows={3}
          placeholder="متن یادداشت را بنویسید…"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
              e.preventDefault();
              submit();
            }
          }}
        />
        <div className="add-comment-actions">
          <button type="button" className="icon-btn" onClick={onClose}>
            انصراف
          </button>
          <button
            type="button"
            className="icon-btn primary"
            disabled={!body.trim()}
            onClick={submit}
          >
            ثبت کامنت
          </button>
        </div>
      </div>
    </div>
  );
}
